<section>
  <div class="container py-5">
    <div class="row py-5">
      <div class="col-md-6">
        <div>
          <p class="m-0 fw-bolder">{{ 'errorPage.code404' | translate }}</p>
          <h1 class="m-0 py-3 fw-bold">{{'errorPage.notFound'|translate}}</h1>
          <p class="m-0 pb-4">{{'errorPage.error'|translate}}</p>
          <div class="text-center">
            <a routerLink="/" class="btn px-3 py-2 my-1 mx-2 text-white">{{'errorPage.home'|translate}}</a>
            <a (click)="goBack()" class="btn px-3 py-2 my-1 mx-2 border"><i class="fa-solid fa-arrow-left" [ngClass]="{'ms-1': isRtl, 'me-1': !isRtl}"></i> {{'errorPage.back'|translate}}</a>
          </div>
        </div>
      </div>
      <div class="col-md-6 pt-5 pt-md-0 d-flex align-items-center">
        <div>
          <img class="w-100" src="assets/imgs/Error404.png" alt="Error">
        </div>
      </div>
    </div>
  </div>
</section>
